import QuickQuoteReceived from "./QuickQuoteReceived";

export default QuickQuoteReceived;
